module.exports = __webpack_public_path__ + "img/tg-icon-black.343b7d59.svg";